









































































































































































































































































































































































































import Vue from "vue";
import { CreateJobForm, Mount, Volumn, CreateTaskData } from "./transform";
import { Form } from "element-ui";
import { axios } from "../../plugins";
import { ModelEnum } from "@/components/MySelectStorage.vue";
import { mapState, mapGetters } from "vuex";
export default Vue.extend({
  name: "TaskEdit",
  components: {},
  props: { projectId: { type: String }, kind: { type: String } },
  data() {
    return {
      dialog: false,
      isEdit: false,
      scroll: {} as any,
      loading: false,
      rules: {
        name: [
          { required: true, type: "string", pattern: /^(?!-)[a-z0-9-]*[^-]$/ }
        ]
        // imageInfo: [{ required: true, type: "array", min: 1 }]
      },
      ruleForm: JSON.parse(JSON.stringify(CreateJobForm)) as CreateTaskData,
      keyOptions: [],
      configOptions: [],
      storageOptions: [],
      ModelEnum,
      editIndex: undefined as any
    };
  },
  computed: {
    ...mapState("LoginInfo", ["userinfo", "project"]),
    ...mapGetters("LoginInfo", ["tenant"])
  },
  watch: {
    ruleForm: {
      deep: true,
      handler() {
        setTimeout(() => {
          // 手动触发滚动条刷新
          this.scroll.scroll && this.scroll.scroll.refresh();
        }, 300);
      }
    }
  },
  mounted() {
    this.getKey();
    this.getConfig();
    this.getStorage();
  },
  methods: {
    // 名称变化 响应
    nameChange(val: string) {
      this.ruleForm.metadata.name = val;
      (this.ruleForm.metadata.labels as any).app = val;
      if (this.ruleForm.kind == "Job") {
        // @ts-ignore
        (this.ruleForm.spec.template.metadata as any).labels.app = val;
      } else {
        (this.ruleForm as any).cronJob.metadata.labels.app = val;
      }
    },
    changeKind(val: any) {
      if (val === "Job") {
        this.ruleForm.kind = "Job";
        this.ruleForm.apiVersion = "batch/v1";
      } else {
        this.ruleForm.kind = "CronJob";
        this.ruleForm.apiVersion = "batch/v1beta1";
      }
    },
    initData(data: any) {
      const formData = Object.assign({}, data);
      if (this.kind != "Task") {
        const {
          concurrencyPolicy,
          schedule,
          startingDeadlineSeconds,
          failedJobsHistoryLimit,
          successfulJobsHistoryLimit
        } = data.spec;
        const spec = Object.assign({}, data.spec.jobTemplate.spec);
        const metadata = Object.assign({}, data.spec.jobTemplate.metadata);
        delete formData.spec;
        formData.cronJob = {
          concurrencyPolicy,
          schedule,
          startingDeadlineSeconds,
          failedJobsHistoryLimit,
          successfulJobsHistoryLimit,
          metadata
        };
        formData.spec = spec;
        formData.kind = "CronJob";
        formData.apiVersion = "batch/v1beta1";
      } else {
        formData.kind = "Job";
        formData.apiVersion = "batch/v1";
      }
      return formData;
    },
    show(data?: any) {
      if (data) {
        this.ruleForm = this.initData(data);
        this.isEdit = true;
      } else {
        this.isEdit = false;
      }
      this.dialog = true;
    },
    showSeleckImage(data?: any) {
      console.log(data?.index);
      if (data?.index > -1) {
        // 判断编辑状态 设置编辑的数组子下标
        (this.$refs.selectImage as any).show(
          data?.data,
          // 编辑 image时 将 imagePullSecrets 传回编辑页面
          this.ruleForm.spec.template.spec.imagePullSecrets?.[data?.index]
        );
        this.editIndex = data?.index;
      } else {
        (this.$refs.selectImage as any).show();
      }
    },
    addImage({ data, info, secret }: any) {
      const newData = JSON.parse(data);
      newData.info = JSON.parse(info);
      if (this.editIndex !== undefined) {
        this.ruleForm.spec.template.spec.containers.splice(
          this.editIndex,
          1,
          newData
        );

        (this.ruleForm.spec.template.spec.imagePullSecrets as any[]).splice(
          this.editIndex,
          1,
          secret
        );
        this.editIndex = undefined;
      } else {
        this.ruleForm.spec.template.spec.containers.push(newData);
        (this.ruleForm.spec.template.spec.imagePullSecrets as any).push(secret);
      }
    },
    delImage(index: number) {
      this.ruleForm.spec.template.spec.containers.splice(index, 1);
      (this.ruleForm.spec.template.spec.imagePullSecrets as any).splice(
        index,
        1
      );
    },
    showVolumn(data: any) {
      if (typeof data === "number") {
        if (data === 0) {
          (this.$refs.storage as any).show();
        } else {
          (this.$refs.config as any).show();
        }
      } else {
        // 编辑
        if (
          data.data["persistentVolumeClaim"] ||
          data.data["emptyDir"] ||
          data.data["hostPath"]
        ) {
          // 存储卷
          (this.$refs.storage as any).show(data.data);
        } else {
          (this.$refs.config as any).show(data.data);
        }
        this.editIndex = data.index;
      }
    },
    addVolumn({ data, images }: any) {
      const newData = JSON.parse(data);
      const newImages: Mount[] = JSON.parse(images);
      if (this.editIndex !== undefined) {
        this.ruleForm.spec.template.spec.volumes.splice(
          this.editIndex,
          1,
          newData
        );
        this.editIndex = undefined;
      } else {
        if (!this.ruleForm.spec.template.spec.volumes) {
          this.ruleForm.spec.template.spec.volumes = [];
        }
        this.ruleForm.spec.template.spec.volumes.push(newData);
      }

      if (newImages.length) {
        // 挂载
        this.bindImage(newImages, newData.name);
      } else {
        // 解除绑定
        this.unbindImage(newData.name);
      }
    },
    delVolumn(index: number) {
      const data = (this.ruleForm.spec.template as any).spec.volumes.splice(
        index,
        1
      );
      // 解除镜像绑定
      this.unbindImage(data[0].name);
    },
    showSeleckTemplete(data?: any) {
      (this.$refs.templete as any).show(data?.data);
      this.editIndex = data?.index;
    },
    addTemplete({ data, images }: any) {
      const newData = JSON.parse(data);
      const newImages: Mount[] = JSON.parse(images);

      if (this.editIndex !== undefined) {
        (this.ruleForm.spec.volumeClaimTemplates as any).splice(
          this.editIndex,
          1,
          newData
        );
        this.editIndex = undefined;
      } else {
        (this.ruleForm.spec.volumeClaimTemplates as any).push(newData);
      }

      if (newImages.length) {
        // 挂载
        this.bindImage(newImages, newData.metadata.name);
      } else {
        // 解除绑定
        this.unbindImage(newData.metadata.name);
      }
    },
    delTemplete(index: number) {
      const data = (this.ruleForm.spec.volumeClaimTemplates as any).splice(
        index,
        1
      );
      // 解除镜像绑定
      this.unbindImage(data[0].metadata.name);
    },
    // 容器绑定
    bindImage(newImages: Mount[], name: string) {
      // 挂载
      (this.ruleForm.spec.template as any).spec.containers.forEach(
        (item: any) => {
          const bindImage = newImages.find(m => m.name === item.name);
          // 存储卷绑定该镜像
          if (bindImage) {
            if (!item.volumeMounts) {
              // 镜像未绑定过此存储卷
              item.volumeMounts = [];
              item.volumeMounts.push({
                name: name,
                readOnly: bindImage.readOnly,
                mountPath: bindImage.mountPath,
                subPath: bindImage.subPath
              });
            }
            const index = item.volumeMounts.findIndex(
              (v: any) => v.name === name
            );
            // 镜像绑定过存储卷
            if (index > -1) {
              item.volumeMounts[index].readOnly = bindImage.readOnly;
              item.volumeMounts[index].mountPath = bindImage.mountPath;
              item.volumeMounts[index].subPath = bindImage.subPath;
            } else {
              // 镜像未绑定过此存储卷
              item.volumeMounts.push({
                name: name,
                readOnly: bindImage.readOnly,
                mountPath: bindImage.mountPath,
                subPath: bindImage.subPath
              });
            }
          }
        }
      );
    },
    // 容器解除绑定
    unbindImage(name: string) {
      // 解除镜像绑定
      this.ruleForm.spec.template.spec.containers.forEach(container => {
        const index = container.volumeMounts.findIndex(
          volumn => volumn.name === name
        );
        if (index > -1) {
          container.volumeMounts.splice(index, 1);
        }
      });
    },
    // 获取密钥
    getKey() {
      axios.get(`/secret/list?projectId=${this.projectId}`).then(res => {
        this.keyOptions = res.data.data;
      });
    },
    // 获取配置
    getConfig() {
      axios.get(`/configmap/${this.projectId}`).then(res => {
        this.configOptions = res.data.data.items;
      });
    },
    // 获取存储列表
    getStorage() {
      axios.get(`/storage/${this.projectId}`).then(res => {
        this.storageOptions = res.data.data;
      });
    },
    findStorage(name: string) {
      return (this.storageOptions as any[]).find(item => item.name === name);
    },
    findVolumn(name: string) {
      const data: Volumn[] = [];
      this.ruleForm.spec.template.spec.containers.forEach(contaner => {
        contaner.volumeMounts.forEach(volumn => {
          if (volumn.name === name) {
            data.push({
              name: contaner.name,
              mountPath: volumn.mountPath
            });
          }
        });
      });
      return data;
    },
    quit() {
      this.ruleForm = (this as any).$options.data().ruleForm;
      (this.$refs.ruleForm as Form).resetFields();
      this.dialog = false;
      this.$emit("afterClose");
    },
    buildData() {
      const data = JSON.parse(JSON.stringify(this.ruleForm));
      this.ruleForm.spec.template.spec.containers.forEach(constainer => {
        delete (constainer as any).info;
      });
      data.metadata.namespace = `${this.tenant.code}-${this.project.projectName}`;
      if (data.kind == "Job") {
        delete data.cronJob;
      } else {
        const {
          concurrencyPolicy,
          schedule,
          startingDeadlineSeconds,
          failedJobsHistoryLimit,
          successfulJobsHistoryLimit
        } = data.cronJob;
        const metadata = Object.assign({}, data.cronJob.metadata);
        const spec = Object.assign({}, data.spec);
        delete data.cronJob;
        delete data.spec;
        data.spec = {
          concurrencyPolicy,
          schedule,
          startingDeadlineSeconds,
          failedJobsHistoryLimit,
          successfulJobsHistoryLimit,
          jobTemplate: {
            metadata,
            spec
          }
        };
      }
      return data;
    },
    submit() {
      (this.$refs.ruleForm as Form).validate(vakid => {
        if (vakid) {
          this.loading = true;
          const data = this.buildData();
          let url = { header: "", tail: "" };
          if (data.kind === "Job") {
            url = {
              header: "jobs",
              tail: "job"
            };
          } else {
            url = {
              header: "cronJobs",
              tail: "cronJob"
            };
          }
          if (this.isEdit) {
            this.edit(url, data);
          } else {
            this.create(url, data);
          }
        }
      });
    },
    create(url: any, data: any) {
      axios
        .post(`/${url.header}/${this.projectId}/${url.tail}`, data)
        .then(() => {
          this.$message.success("任务创建成功");
          this.quit();
          this.$emit("afterEdit");
        })
        .finally(() => {
          this.loading = false;
        });
    },
    edit(url: any, data: any) {
      axios
        .patch(
          `/${url.header}/${this.projectId}/${url.tail}/${data.metadata.name}`,
          data
        )
        .then(() => {
          this.$message.success("任务编辑成功");
          this.quit();
          this.$emit("afterEdit");
        })
        .finally(() => {
          this.loading = false;
        });
    },
    close() {
      this.quit();
    }
  }
});
